import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TripPurpose, TripPurposesTypes } from '@ridango/components/lib/corporate-employees/corporate-employees.models';

@Component({
    selector: 'gl-select-purpose-modal',
    templateUrl: './select-purpose-modal.component.html',
    styleUrls: ['./select-purpose-modal.component.scss']
})
export class SelectPurposeModalComponent {
    @Input() purposes: TripPurpose[];
    @Input() selectedPurpose: TripPurpose | null;

    public tripPurposes = TripPurposesTypes;

    constructor(private modalCtrl: ModalController) {}

    public onPurposeChange(purpose: TripPurpose): void {
        this.selectedPurpose = purpose;
    }

    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    public async handleSaveClick() {
        if (this.selectedPurpose?.title) {
            await this.modalCtrl.dismiss(this.selectedPurpose, 'submit');
        }
    }
}
